export function getResponseError(err) {
  if (err && err.isAxiosError) {
    if (err.response) {
      const { response: { data: errData } } = err;
      return errData;
    }
    return { message: 'Ops! Ocorreu um erro inesperado. Tente novamente em instantes.' };
  }
  return err;
}
